import React, { useEffect } from 'react';
import api from '../services/apiClient';

import AddImageLogo from './AddImageLogo';

interface ClienteLogoProps {
  imgFileLogoEmpresa: File | null;
  setImgFileLogoEmpresa: (file: File) => void;
  imgFileLogoCliente: File | null;
  setImgFileLogoCliente: (file: File) => void;
}

const ClientLogo = ({
  imgFileLogoEmpresa,
  setImgFileLogoEmpresa,
  imgFileLogoCliente,
  setImgFileLogoCliente,
}: ClienteLogoProps): JSX.Element => {
  const loadLogoEmpresa = async (): Promise<void> => {
    const token = localStorage.getItem('@LiveChat:token');

    const response = await api.get('/api/Imagem/LogoEmpresa', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });

    const fileName = response.headers['x-file-name'] || 'logo-empresa';

    // Criar um objeto File com o nome correto
    const file = new File([response.data], fileName, {
      type: response.data.type,
    });
    setImgFileLogoEmpresa(file);
  };

  const loadLogoCliente = async (): Promise<void> => {
    const token = localStorage.getItem('@LiveChat:token');

    const response = await api.get('/api/Imagem/LogoCliente', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      responseType: 'blob',
    });

    const fileName = response.headers['x-file-name'] || 'logo-cliente';

    // Criar um objeto File com o nome correto
    const file = new File([response.data], fileName, {
      type: response.data.type,
    });
    setImgFileLogoCliente(file);
  };

  useEffect(() => {
    loadLogoEmpresa();
    loadLogoCliente();
  }, []);

  return (
    <div className="d-flex flex-column">
      <div>
        <AddImageLogo
          selectedFile={imgFileLogoEmpresa}
          setSelectedFile={setImgFileLogoEmpresa}
          title="Logo da Empresa - LiveChat"
        />
      </div>

      <div className="mt-3">
        <AddImageLogo
          selectedFile={imgFileLogoCliente}
          setSelectedFile={setImgFileLogoCliente}
          title="Logo da Empresa - Cliente"
        />
      </div>
    </div>
  );
};

export default ClientLogo;
